import styled from 'styled-components';
import { Body1, Caption, colors, spacing } from 'ui/theme';

export const StyledRadioListTextWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.base};
`;

export const StyledCaption = styled(Caption)`
  color: ${colors.textSecondary};
`;
export const StyledBody = styled(Body1)`
  margin: 0;
`;

export const AiSparkleWrapper = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background-color: ${colors.purple10};
  width: ${spacing.plusHalf};
  height: ${spacing.plusHalf};
  min-width: ${spacing.plusHalf};
`;

export const StyledRecommendedCardContent = styled.div`
  padding-right: ${spacing.half};
`;
